import _ from "lodash";
import * as Yup from "yup";
import { useState } from "react";
import { FormInput } from "../../common/form-controllers/FormInput";
import { useFormik } from "formik";
import { ToastService } from "../../../services/toast.service";
import { useSearchParams } from "react-router-dom";
import { PROGRAM_CATEGORY } from "../../../consts/methods.consts";
import { PageHeaderActions } from "../../common/page-header/PageHeader";
import { useTableDataProvider } from "../../hooks";
import { DROPDOWN_TAGS, PROGRAM_CATEGORY_TAGS } from "../../../consts/tags.consts";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { ChakraModal, PageHeader } from "../../index";
import { useGetQuery, usePostMutation } from "../../../services/api.service";
import ChakraTable, { ChakraTableColumns } from "../../common/chakra-table/ChakraTable";
import { customeJsonParser } from "../../../utils/utils";


const ProgramCategoryListPage = () => {

    const disclosure = useDisclosure()
    const [searchParams] = useSearchParams()
    const [page, setPage] = useState(1)
    const toast = new ToastService(useToast())
    const [isSelected, setIsSelected] = useState<boolean>(false);
    const [create] = usePostMutation();

    const { data, isLoading, isFetching } = useGetQuery({
        method: PROGRAM_CATEGORY.LIST,
        body: {
            page: page,
        },
        providesTags: [PROGRAM_CATEGORY_TAGS.LIST]
    })

    const { dataList, paginationDetails } = useTableDataProvider(data);

    const formik = useFormik({
        initialValues: {
            title: ''
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Name is required"),
        }),
        onSubmit: async (values) => {
            try {
                await create({
                    method: isSelected ? PROGRAM_CATEGORY.UPDATE : PROGRAM_CATEGORY.ADD,
                    body: values,
                    invalidatesTags: [PROGRAM_CATEGORY_TAGS.LIST, DROPDOWN_TAGS.LIST]
                }).unwrap();

                toast.setTitle("Success").setDescription(`${isSelected ? "Program category details have been saved" : "Program category has been created successfully"}`).showSuccessToast();

            } catch (error: any) {
                let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
                if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();
                console.error(error);
            } finally {
                disclosure.onClose();
                setIsSelected(false);
            }
        }
    })

    const ondeleteHandler = async (item: any) => {
        try {
            const res = await create({
                method: PROGRAM_CATEGORY.DELETE,
                body: { id: item?.name },
                invalidatesTags: [PROGRAM_CATEGORY_TAGS.LIST, DROPDOWN_TAGS.LIST]
            }).unwrap();

            toast.setTitle("Success").setDescription("Program category is deleted successfully.").showSuccessToast();

        } catch (error: any) {
            let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
            if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();
        }

    }

    const PROGRAM_CATEGORY_COLUMNS: ChakraTableColumns = [
        {
            header: "Name",
            accessor:
                "title",
        },
        {
            header: "Actions",
            accessor: '',
            disabled: false,
            width: 100,
            options: [
                {
                    label: "Edit",
                    confirmation: false,
                    onClick(item) {
                        formik.setFieldValue("title", _.get(item, "title"))
                        formik.setFieldValue("name", _.get(item, "name"))
                        setIsSelected(true)
                        disclosure.onOpen()
                    },
                },
                {
                    label: "Delete",
                    onClick: ondeleteHandler,
                }
            ]
        }
    ]


    const actions: PageHeaderActions = [

        {
            text: "Create New",
            confirmation: false,
            onClick: () => {
                setIsSelected(false)
                formik.resetForm();
                disclosure.onOpen()
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]

    const onPage = (page: any) => {
        setPage(page)
    }

    return (
        <>
            <div>
                <PageHeader subtitle="View and Manage Programs Categories" title={`Programs Categories`} actions={actions} />
                <ChakraTable onPage={onPage} isFetching={isFetching} paginationDetails={paginationDetails} isLoading={isLoading} pagination size={"sm"} header
                    title="Programs Categories"
                    columns={PROGRAM_CATEGORY_COLUMNS} data={dataList} />
                <ChakraModal primaryAction={formik.submitForm} primaryButtonText={"Save"} modalTitle={`${isSelected ? 'Edit Program Category' : 'New Program Category'}`} {...disclosure}>
                    <FormInput isRequired formik={formik} name="title" autoFocus label="Name" />
                </ChakraModal>
            </div>
        </>
    )
}

export default ProgramCategoryListPage